import { Object3D } from "three";
import { CoreLoaderGeometry } from "../Geometry";
import { CoreBaseLoader } from "../_Base";
export class BaseGeoLoader {
}
export class BaseGeoLoaderHandler extends CoreBaseLoader {
  reset() {
    this._loader = void 0;
  }
  async load(options) {
    const loader = await this._getLoader(options);
    if (!loader) {
      console.warn("no loader", this);
      return;
    }
    const url = await this._urlToLoad();
    return new Promise(async (resolve) => {
      CoreLoaderGeometry.incrementInProgressLoadsCount();
      await CoreLoaderGeometry.waitForMaxConcurrentLoadsQueueFreed();
      loader.load(url, (object) => {
        CoreLoaderGeometry.decrementInProgressLoadsCount();
        const newObjects = this._onLoadSuccessGLTF(object);
        resolve(newObjects);
      }, (progress) => {
      }, (event) => {
        var _a;
        CoreLoaderGeometry.decrementInProgressLoadsCount();
        const message = `could not load geometry from ${url} (Error: ${event.message})`;
        (_a = options.node) == null ? void 0 : _a.states.error.set(message);
      });
    });
  }
  _onLoadSuccessGLTF(o) {
    if (o instanceof Object3D) {
      return [o];
    } else {
      return [];
    }
  }
}
